module.exports = __webpack_public_path__ + "static/media/docker.530d80a8.svg";